var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScormtincan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.122,
    height: 107.141,
    viewBox: "0 0 107.122 107.141",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scorm-tincan",
    transform: "translate(-74 -806.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20556",
    "data-name": "Group 20556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ppt-icon",
    transform: "translate(0 440)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20331",
    "data-name": "Group 20331",
    transform: "translate(-315 170.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_198",
    "data-name": "Union 198",
    d: "M2384.695-14276.561a53.21,53.21,0,0,1-15.694-37.883,53.2,53.2,0,0,1,15.7-37.867,53.211,53.211,0,0,1,37.865-15.7,53.193,53.193,0,0,1,37.868,15.691,53.2,53.2,0,0,1,15.693,37.867,53.249,53.249,0,0,1-15.695,37.887,53.205,53.205,0,0,1-37.866,15.7A53.21,53.21,0,0,1,2384.695-14276.561Zm-10.712-37.883a48.635,48.635,0,0,0,48.578,48.578,48.628,48.628,0,0,0,48.579-48.578,48.623,48.623,0,0,0-48.579-48.578,48.629,48.629,0,0,0-48.578,48.594Z",
    transform: "translate(-1980 14563.999)",
    fill: "#6b6b6b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_173",
    "data-name": "Subtraction 173",
    d: "M-12625.905-20309.6h-29.833a4.281,4.281,0,0,1-4.263-4.262v-38.354a4.273,4.273,0,0,1,4.263-4.262h4.263v-4.264a4.267,4.267,0,0,1,4.263-4.262h21.308a2.131,2.131,0,0,1,1.507.623l10.651,10.656a2.146,2.146,0,0,1,.624,1.508v29.828a4.267,4.267,0,0,1-4.263,4.262h-4.258v4.264A4.281,4.281,0,0,1-12625.905-20309.6Zm-21.308-14.914a2.131,2.131,0,0,0-2.132,2.127,2.133,2.133,0,0,0,2.132,2.131h12.782a2.133,2.133,0,0,0,2.131-2.131,2.131,2.131,0,0,0-2.131-2.127Zm0-36.227h0v4.264h12.782a2.117,2.117,0,0,1,1.508.623l10.651,10.65a2.123,2.123,0,0,1,.628,1.508v21.309h4.258v-28.949l-9.4-9.4Zm0,27.7a2.135,2.135,0,0,0-2.132,2.133,2.133,2.133,0,0,0,2.132,2.131h12.782a2.133,2.133,0,0,0,2.131-2.131,2.135,2.135,0,0,0-2.131-2.133Zm.214-7.963a2,2,0,0,0-2,2,2,2,0,0,0,2,2h12a2,2,0,0,0,2-2,2,2,0,0,0-2-2Z",
    transform: "translate(12764 21197)",
    fill: "#6b6b6b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScormtincan);
export default __webpack_public_path__ + "static/media/scormtincan.2bc0d1d9dd5f31640e31a174bea67c47.svg";
export { ForwardRef as ReactComponent };